import { HelpParameters, Help, HelpPanelColor } from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
import { Panel, ButtonColors } from "../panel/panel";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { SlotGameType1_2Screen } from "../SlotGameType1_2Screen";
import { MarkersInfoColors } from "../WinLineInfoMarkers";
export class LuckyFire5_2Screen extends SlotGameType1_2Screen {
    protected override helpFactory: IHelpFactory = new LuckyFire5HelpFactory();
    protected override panelFactory: IPanelFactory = new LuckyFire5PanelFactory();
    //LED COLOR
    protected override ColorLed: string = "250,0,0\n";

    constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
        super(multigameParams, initData, "LuckyFire5");
        this.spinnableReelsParams.topBorderWidth = 0;
        this.spinnableReelsParams.bottomBorderWidth = 0;
    }
    //SEND COLOR 
    protected override color: RewardColor =
        {
            color: "white",
            coloroutherStroke: "black",
            colorinnerStroke: "red",
        }

        protected override colorLineMarkers: MarkersInfoColors =
		{
			MarkerbackgroundColor: "linear-gradient(90deg, rgb(38, 2, 89),rgb(38, 2, 89), rgb(126,61,191),rgb(38, 2, 89),rgb(38, 2, 89)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
		};
}

//Help Colorized
class LuckyFire5HelpFactory implements IHelpFactory {
    public CreateNewHelp(params: HelpParameters): Help {
        return new LuckyFire5Help(params);
    }
}

class LuckyFire5Help extends Help {
    protected override BackgroundPanel(): HelpPanelColor {
        let color: HelpPanelColor = {
            backgroundPanelColor: "linear-gradient(rgb(38, 2, 89),rgb(59, 2, 115), rgb(126,61,191),rgb(59, 2, 115),rgb(38, 2, 89)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
        };
        return color;
    }
}

//Panel Colorized
class LuckyFire5PanelFactory implements IPanelFactory {
    public CreateNewPanel(params: PanelParams): Panel {
        return new LuckyFire5Panel(params);
    }
}

class LuckyFire5Panel extends Panel {
    protected override ButtonBackground(): ButtonColors {
        let color: ButtonColors = {
            backgroundButtonColor: "linear-gradient(rgb(38, 2, 89),rgb(59, 2, 115), rgb(126,61,191),rgb(59, 2, 115),rgb(38, 2, 89)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
            linearColor: "linear-gradient(to left , transparent, rgb(242, 115, 41),transparent ) 0 10 100%",
        };
        return color;
    }
}